/** @format */

export const useSelectA11y = () => {
    const getRootProps = () => ({
        role: 'listbox',
    });

    const getToggleButtonProps = (
        isOpen: boolean,
        closeMenuAriaLabel: string,
        openMenuAriaLabel: string
    ) => ({
        'aria-label': isOpen ? closeMenuAriaLabel : openMenuAriaLabel,
        'aria-haspopup': true,
    });

    const getLabelProps = (id: string) => ({
        id: `${id}-label`,
    });

    const getMenuProps = (id: string) => ({
        id: `${id}-menu`,
        role: 'listbox',
        'aria-labelledby': `${id}-label`,
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-return -- Legacy code: do not use as an example.
    const getItemProps = ({ isSelected, ...others }: any) => ({
        role: 'option',
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- Legacy code: do not use as an example.
        'aria-selected': isSelected,
        ...others,
    });

    return {
        getRootProps,
        getToggleButtonProps,
        getLabelProps,
        getMenuProps,
        getItemProps,
    };
};
